import '../../venn-frontend/src/venn-shell/src/polyfills';
import * as React from 'react';
import ReactDOM from 'react-dom';
import CookieStyles from './cookie-styles';
import { CookieBanner } from 'venn-components';
import CookiePreferencesLaunchPoint from './components/CookiePreferencesLaunchPoint';
import { ShellThemeProvider } from 'venn-ui-kit';
import { VennQueryClient, QueryClientProvider, useInitializeFeatures } from 'venn-utils';
import { useEffect } from 'react';
import { RecoilRoot } from 'recoil';

const queryClient = VennQueryClient.getInstance();

const CookieComplianceComponent = () => {
  const initializeFeatures = useInitializeFeatures('ABSOLUTE_PATH');

  useEffect(() => {
    initializeFeatures();
  }, [initializeFeatures]);

  return (
    <QueryClientProvider client={queryClient}>
      <ShellThemeProvider>
        <CookieStyles>
          <CookieBanner />
          <CookiePreferencesLaunchPoint />
        </CookieStyles>
      </ShellThemeProvider>
    </QueryClientProvider>
  );
};

if (window.Cypress) {
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <RecoilRoot>
      <CookieComplianceComponent />
    </RecoilRoot>,
    document.getElementById('cookie-root'),
  );
} else {
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <React.StrictMode>
      <RecoilRoot>
        <CookieComplianceComponent />
      </RecoilRoot>
    </React.StrictMode>,
    document.getElementById('cookie-root'),
  );
}
